export default {
  namespaced: true,
  state: {
    deviceList: [], // 物联设备列表
    devices: [] // 模糊检索物联设备
  },
  actions: {
    // 新增物联设备信息
    async addDevice({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/device/info',
          data: data,
          msg: '新增物联设备信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除物联设备信息
    async deleteDevice({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/device/info',
          data: { uid: uid },
          msg: '删除物联设备信息成功'
        },
        { root: true }
      )
      return res
    },
    // 根据设备编号查询物联设备数据
    async getDevices({ commit, dispatch }, deviceCode) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/device/info',
          data: { deviceCode: deviceCode }
        },
        { root: true }
      )
      var devices = res.data ? res.data : []
      devices.forEach((item) => {
        item.value = item.uid
        item.label =
          item.deviceCode +
          '\xa0\xa0' +
          item.deviceType +
          (item.thirdDeviceCode
            ? '\xa0\xa0\xa0\xa0(厂家编号：' + item.thirdDeviceCode + ')'
            : '')
      })
      commit(
        'baseSet',
        { module: 'device', key: 'devices', value: devices },
        { root: true }
      )
    },
    // 编辑物联设备信息
    async editDevice({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/device/info',
          data: data,
          msg: '编辑物联设备信息成功'
        },
        { root: true }
      )
      return res
    },
    // 给监控主体关联物联设备
    async relatedDevice({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/car/device',
          data: data,
          msg: '关联物联设备成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑物联设备关联关系
    async editDeviceRelevance({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/car/device',
          data: data,
          msg: '编辑物联设备成功'
        },
        { root: true }
      )
      return res
    },
    // 解除物联设备关联关系
    async deleteDeviceRelevance({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/car/device',
          data: { uid: uid },
          msg: '解除物联设备成功'
        },
        { root: true }
      )
      return res
    }
  }
}
